import { FaAmazon } from "react-icons/fa";

const LetterIcon = (letter) => ({ size = 22 }) => (
  <span style={{ fontSize: size * 0.7, fontWeight: 800, fontFamily: "Outfit" }}>{letter}</span>
);
const FlipkartIcon = LetterIcon("Fk");
const BlinkitIcon = LetterIcon("b");
const FirstcryIcon = LetterIcon("fc");

export const PLATFORM_META = {
  amazon: { name: "Amazon", Icon: FaAmazon, bg: "#232F3E", fg: "#FF9900", accent: "#FF9900" },
  flipkart: { name: "Flipkart", Icon: FlipkartIcon, bg: "#2874F0", fg: "#FFE11B", accent: "#2874F0" },
  blinkit: { name: "Blinkit", Icon: BlinkitIcon, bg: "#F8CB46", fg: "#0C831F", accent: "#F0C132" },
  firstcry: { name: "Firstcry", Icon: FirstcryIcon, bg: "#FDE3EC", fg: "#C9236A", accent: "#C9236A" },
};

export const STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  pending_approval: { label: "Pending Approval", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-800 border-red-300" },
  einvoiced: { label: "E-Invoiced", cls: "bg-blue-50 text-blue-800 border-blue-300" },
  einvoice_failed: { label: "E-Invoice Failed", cls: "bg-red-50 text-red-700 border-red-300" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-600 border-slate-400 line-through" },
};

export function PlatformBadge({ platform, size = 18 }) {
  const m = PLATFORM_META[platform];
  if (!m) return null;
  const { Icon } = m;
  return (
    <span
      className="inline-flex items-center justify-center rounded-md shrink-0"
      style={{ background: m.bg, color: m.fg, width: size + 10, height: size + 10 }}
    >
      <Icon size={size} />
    </span>
  );
}

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-300" };
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${m.cls}`}>
      {m.label}
    </span>
  );
}

export const inr = (v) => "₹" + Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
